export const incomeRangeOptions = [
    "Under150Thousand",
    "Under250Thousand",
    "Under500Thousand",
    "Under1Million",
    "Over1Million",
];
//# sourceMappingURL=incomeRange.js.map